import { config } from '#@/platform/networking/client/lib/config'
import type { Extension } from '#@/platform/networking/client/types/extension'
import type { MarketplaceGid } from '#@/platform/types/marketplace/marketplaceGid'

export const graph: Extension = {
  apply(client) {
    client.setEndpoint(config.utilities.getServiceUrl('graph'))
  },
} as const

export const django: Extension = {
  tag: 'django',
  apply(client) {
    client.setEndpoint(config.utilities.getServiceUrl('django'))
  },
} as const

/**
 * Admin-api. Receives the marketplace explicitly because callers hold a global, non-marketplace-bound client key. The
 * admin-api determines the marketplace scope for each request from this header.
 */
export function aapi(marketplaceId: MarketplaceGid | null): Extension {
  return {
    tag: 'aapi',
    apply(client) {
      client.setEndpoint(config.utilities.getServiceUrl('aapi'))

      if (marketplaceId) {
        client.addMiddleware((request) => {
          const headers = new Headers(request.headers)
          headers.set('district-marketplace-id', marketplaceId)
          return { ...request, headers }
        })
      }
    },
  } as const
}

/**
 * ShipHero sync worker. Receives the marketplace explicitly because callers hold a global, non-marketplace-bound client
 * key.
 */
export function shiphero(marketplaceId: MarketplaceGid | null): Extension {
  return {
    tag: 'shiphero',
    apply(client) {
      client.setEndpoint(config.utilities.getServiceUrl('shiphero'))

      if (marketplaceId) {
        client.addMiddleware((request) => {
          const headers = new Headers(request.headers)
          headers.set('district-marketplace-id', marketplaceId)
          return { ...request, headers }
        })
      }
    },
  } as const
}

export function mapi(marketplaceId: MarketplaceGid | null): Extension {
  return {
    tag: 'mapi',
    apply(client) {
      client.setEndpoint(config.utilities.getServiceUrl('mapi'))

      if (marketplaceId) {
        client.addMiddleware((request) => {
          const headers = new Headers(request.headers)
          headers.set('district-marketplace-id', marketplaceId)
          return { ...request, headers }
        })
      }
    },
  } as const
}
